module.exports = __webpack_public_path__ + "static/media/fishpool.ef6f516e.svg";